export const env = {
    BACKEND: 'https://kaabil.net/apinetdb',
    // BACKEND: 'http://localhost:9011',
    BASE_URL: '/apinet',
    PUBLIC_URL: 'http://0.0.0.0:9010',
}
